import { createTRPCReact } from '@trpc/react-query';
import type { inferRouterOutputs, inferRouterInputs } from '@trpc/server';

import { APIRouter } from 'server/supabase/interface';

export const trpc = createTRPCReact<APIRouter>({});
export type RouterOutput = inferRouterOutputs<APIRouter>;
export type RouterInput = inferRouterInputs<APIRouter>;
